import { createAsyncThunk, createReducer } from "@reduxjs/toolkit";
import {
  addActivedFlow,
  clearActivedFlows,
  clearActivedPane,
  undoActivedFlow,
  confirmTask,
  updateSubtask,
  updateDescription,
  updateAccountable,
  updateAccountableTask,
  updateMultipleACC,
  updateTaskLabel,
  addCustomNote,
  updateCustomNote,
  removeCustomNote,
  activateOverlayForAdd,
  activateOverlayForMove,
  deactivateOverlay,
  updateTaskDuration,
  updateTaskDeadline,
  updateFlowStatus,
  renameActivedFlow,
} from "./actions";
import api from "../../services/api";

export const fetchActivedFlows = createAsyncThunk(
  "activedFlows/fetchActivedFlows",
  async ({ page, queries = {} }, { rejectWithValue }) => {
    const { filters } = queries;
    try {
      const query =
        "?title=" +
        filters.title +
        "&client=" +
        filters.client +
        "&alpha=" +
        filters.alpha +
        "&creation=" +
        filters.creation;

      const response = await api.get(
        "/activedflows/pagination/" + page + "/" + query
      );
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchSingleActivedFlow = createAsyncThunk(
  "activedflows/fetchSingle",
  async ({ _id }, { rejectWithValue }) => {
    try {
      const response = await api.get("/activedflows/flow/" + _id);
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const activedFlowsReducer = createReducer(
  {
    pagination: { status: "idle", flows: [], pages: 1 },
    pane: { status: "idle", flow: {} },
    overlay: {
      isActive: false,
      operation: null,
      noteId: null,
      flowId: null,
      noteStyle: null,
    },
  },
  {
    [fetchActivedFlows.pending]: (state, action) => {
      state.pagination.status = "loading";
    },
    [fetchActivedFlows.fulfilled]: (state, action) => {
      state.pagination.status = "succeeded";
      state.pagination.flows = action.payload.activedflows;
      state.pagination.pages = action.payload.pages;
    },

    [fetchSingleActivedFlow.pending]: (state, action) => {
      state.pane.status = "loading";
    },

    [fetchSingleActivedFlow.fulfilled]: (state, action) => {
      state.pane.status = "succeeded";
      state.pane.flow = action.payload.flow;
    },

    [addActivedFlow]: (state, action) => {},
    [clearActivedPane]: (state) => {
      state.pane.status = "idle";
      state.pane.flow = {};
    },

    [undoActivedFlow]: (state, action) => {
      const flow = action.payload.flow;

      state.pane.flow = {
        ...state.pane.flow,
        status: flow.status,
        finishedAt: flow.finishedAt,
        comments: flow.comments,
        lastState: flow.lastState,
        elements: flow.elements,
      };
    },
    [confirmTask]: (state, action) => {
      const flow = action.payload.flow;

      state.pane.flow = {
        ...state.pane.flow,
        status: flow.status,
        finishedAt: flow.finishedAt,
        comments: flow.comments,
        lastState: flow.lastState,
        elements: flow.elements,
      };
    },

    [updateSubtask]: (state, action) => {
      const subtasks = action.payload.subtasks;
      const taskId = action.payload.taskId;

      state.pane.flow.elements.map((item) =>
        item._id === taskId ? (item.data.subtasks = subtasks) : item
      );
    },

    [updateDescription]: (state, action) => {
      const description = action.payload.description;
      const taskId = action.payload.taskId;

      state.pane.flow.elements.map((item) =>
        item._id === taskId ? (item.data.comments = description) : item
      );
    },
    //flow
    [updateAccountable]: (state, action) => {
      const accountable = action.payload.accountable;

      state.pane.flow = { ...state.pane.flow, accountable };
    },
    //task
    [updateAccountableTask]: (state, action) => {
      const accountable = action.payload.accountable;
      const taskId = action.payload.taskId;

      state.pane.flow.elements.map((item) =>
        item._id === taskId ? (item.data.accountable = accountable) : item
      );
    },

    //task
    [updateTaskLabel]: (state, action) => {
      const label = action.payload.label;
      const taskId = action.payload.taskId;

      state.pane.flow.elements.map((item) =>
        item._id === taskId ? (item.data.label = label) : item
      );
    },

    [updateMultipleACC]: (state, action) => {
      const list = action.payload.list;
      const accountable = action.payload.accountable;

      state.pane.flow.elements.map((item) => {
        const task = list.find((t) => t.taskId === item._id);

        if (task) {
          item.data.accountable = accountable;
          return item;
        }
        return item;
      });
    },

    //Atualizar prazo de tarefa
    [updateTaskDeadline]: (state, action) => {
      const task = action.payload;

      state.pane.flow.elements.map((item) => {
        if (item._id === task._id) {
          item.data.expiration = task.data.expiration;
        }
        return item;
      });
    },

    [updateFlowStatus]: (state, action) => {
      const { criticalDate, estimatedAt, activeJobs } = action.payload;
      let { progress } = action.payload;
      progress = progress === null || progress === undefined ? 0 : progress;

      if (criticalDate !== undefined && estimatedAt !== undefined) {
        state.pane.flow.flowStatus = {
          ...state.pane.flow.flowStatus,
          criticalDate,
          estimatedAt,
          progress,
          activeJobs,
        };
      }
    },
    /**
     * ? clearActivedFlows
     ** Limpa o estado atual localmente de fluxos ativos cadastrados;
     */

    [clearActivedFlows]: (state) => {
      state.status = "idle";
      state.entities = [];
    },

    //* CustomNotes Block

    [addCustomNote]: (state, action) => {
      state.pane.flow.elements = [...state.pane.flow.elements, action.payload];
    },

    [updateCustomNote]: (state, action) => {
      state.pane.flow.elements = state.pane.flow.elements.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload } : item
      );
    },

    [removeCustomNote]: (state, action) => {
      state.pane.flow.elements = state.pane.flow.elements.filter(
        (item) => item.id !== action.payload.id
      );
    },

    //* Overlay Block

    [activateOverlayForAdd]: (state, action) => {
      state.overlay = {
        isActive: true,
        operation: "add",
        noteId: null,
        flowId: action.payload.flowId,
      };
    },

    [activateOverlayForMove]: (state, action) => {
      state.overlay = {
        isActive: true,
        operation: "move",
        noteId: action.payload.noteId,
        flowId: action.payload.flowId,
        noteStyle: action.payload.noteStyle,
      };
    },

    [deactivateOverlay]: (state) => {
      state.overlay = {
        isActive: false,
        operation: null,
        noteId: null,
        flowId: null,
        noteStyle: null,
      };
    },
    [updateTaskDuration]: (state, action) => {
      const { taskId, duration } = action.payload;
      state.pane.flow.elements = state.pane.flow.elements.map((task) =>
        task._id === taskId
          ? { ...task, data: { ...task.data, duration } }
          : task
      );
    },
    [renameActivedFlow]: (state, action) => {
      state.pane.flow.title = action.payload.title; 
    },
  }
);

export default activedFlowsReducer;
